import React from "react";
import PropTypes from 'prop-types';
import { TextField } from "../../index";

export const EmailAddress = ({
    label="Email address",
    type="email",
    ...props
}) => {

    return (
        <TextField
            {...props}
            label={label}
            type={type}
        />
    )
}

EmailAddress.propTypes = {
    label: PropTypes.string,
    type: PropTypes.string,
}